import { getUrlWithoutQueryParams } from "../../../../integrations/funcs";

export const bokunSteps = [
  {
    label: "Integration Connection",
    step: 1,
  },
  {
    label: "Integration Details",
    step: 2,
  },
  {
    label: "Integration Products",
    step: 3,
  },
];

export const renderFormSteps = (activeStep: number, changeStep: (url: string) => void) => {
  //   if(activeStep === 1) return <ChooseIntegrationElementsStep handleChangeFormStep={changeStep} />
  //   if(activeStep === 2) return <IntegrationDetailsStep handleChangeFormStep={changeStep} />
  //   if(activeStep === 3) return <IntegrationProductsStep handleChangeFormStep={changeStep} />
};

export interface BokunProps {
  choose_integration_elements: {
    fromIntegrationId: string | null;
    toIntegrationId: string | null;
  };
  fill_integration_details: {
    accountId: number | null;
    partnerId: string | null;
    policy: boolean | null;
    fee: number | null;
  };
  integration_products: {
    integrationProductsComplete: any;
  };
}

export const setActiveStepByUrlOfBokunIntegration = (pathname: string, setActiveStep: (step: number) => void) => {
  let stepPath = getUrlWithoutQueryParams(pathname)[0];
  if (stepPath === "/integrationForm/chooseIntegrationElements") {
    setActiveStep(1);
  } else if (stepPath === "/integrationForm/bokun/fillIntegrationDetails") {
    setActiveStep(2);
  } else if (stepPath === "/integrationForm/bokun/integrationProducts") {
    setActiveStep(3);
  }
};

export const getBokunParamsFromUrlQueryParams = (searchParams: any) => {
  const fromIntegrationId = searchParams.get("fromIntegrationId") || null;
  const toIntegrationId = searchParams.get("toIntegrationId") || null;
  const accountId = searchParams.get("accountId") || null;
  const partnerId = searchParams.get("partnerId") || null;
  const policy = Boolean(searchParams.get("policy"));
  const fee = Number(searchParams.get("fee"));
  const integrationProductsComplete = searchParams.get("integrationProductsComplete");
  return {
    choose_integration_elements: {
      fromIntegrationId,
      toIntegrationId,
    },
    fill_integration_details: {
      accountId,
      partnerId,
      policy,
      fee,
    },
    integration_products: {
      integrationProductsComplete,
    },
  };
};

export const redirectToProperlyStepUrlBokun = (formStepPathname: string, queryParams: string, navigate: any) => {
  const queryParameters = new URLSearchParams(queryParams);
  if (formStepPathname === "/integrationForm/chooseIntegrationElements") {
    navigate(decodeURIComponent(`/integrationForm/chooseIntegrationElements?${queryParameters}`));
  } else if (formStepPathname === "/integrationForm/bokun/fillIntegrationDetails") {
    navigate(decodeURIComponent(`/integrationForm/bokun/fillIntegrationDetails?${queryParameters}`));
  } else if (formStepPathname === `/integrationForm/bokun/integrationProducts`) {
    navigate(decodeURIComponent(`/integrationForm/bokun/integrationProducts?${queryParameters}`));
  }
};

export const initialBokunData: BokunProps | undefined = {
  choose_integration_elements: {
    fromIntegrationId: null,
    toIntegrationId: null,
  },
  fill_integration_details: {
    accountId: null,
    partnerId: null,
    policy: false,
    fee: 0,
  },
  integration_products: {
    integrationProductsComplete: false,
  },
};
